<template>
  <div style="text-align: center; margin-top: 15%;">
    <h1>404 : Not Found</h1>
    <h3>You are requesting a page that does not exist!</h3>
    <h5>Go back to homepage: <a href="/">Quotey Homepage</a></h5>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  mounted() {
    $(".navbar").hide();
  },
};
</script>

<style scoped></style>
